<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'App',
  methods: {
    ...mapMutations(['setBrowserScale']),
    updateBrowserScale() {
      // 这里你可以根据你的需求来计算缩放比
      // 例如，使用window.devicePixelRatio或window.visualViewport.scale（如果可用）
      const newScale = window.devicePixelRatio || 1.0
      // 注意：window.devicePixelRatio并不反映页面的缩放级别，只反映设备的像素比
      // 如果你需要页面的缩放级别，并且浏览器支持visualViewport，你应该使用window.visualViewport.scale

      // 调用Vuex mutation来更新状态
      this.setBrowserScale(newScale)
    }
  },
  mounted() {
    this.updateBrowserScale()
    window.addEventListener('resize', this.updateBrowserScale)
    if ('visualViewport' in window) {
      window.visualViewport.addEventListener('resize', this.updateBrowserScale)
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateBrowserScale)
    if ('visualViewport' in window) {
      window.visualViewport.removeEventListener('resize', this.updateBrowserScale)
    }
  }
}
</script>
<style>
body {
  background-color: #001327;
}
:root {
  /*    --mao-bg-wave01: rgba(240, 248, 255, 0.7);
    --mao-bg-wave02: rgba(240, 248, 255, 0.5);
    --mao-bg-wave03: rgba(240, 248, 255, 0.3);
    --mao-bg-wave04: rgba(240, 248, 255, 1); */
  --mao-bg-wave01: rgba(0, 19, 39, 0.7);
  --mao-bg-wave02: rgba(0, 19, 39, 0.5);
  --mao-bg-wave03: rgba(0, 19, 39, 0.3);
  --mao-bg-wave04: rgba(0, 19, 39, 1);
}
</style>
